export default {
  required: {
    en: 'Required',
  },
  passwordsMatch: {
    en: 'Passwords should match',
  },
  email: {
    en: 'Valid email address required',
  },
  emailAlreadyUsed: {
    en: `
      ERROR! This email has been already registered.
      Please <Link id="alreadyRegisteredLink" className="inputErrorLink" to="/register/log-in">login</Link>
    `,
  },
  emailAlreadyUsedWithoutLink: {
    en: 'ERROR! This email has been already registered. Please login',
  },
  unknownEmail: {
    en: `Unknown email. Please <Link className="inputErrorLink" to="/register">register</Link>`,
  },
  unknownEmailWithoutLink: {
    en: 'Unknown email. Please register',
  },
  url: {
    en: 'Valid url required',
  },
  password: {
    en: 'Password must be 4 characters including alphanumeric and !@#$%^&*()_+-= characters',
  },
  integer: {
    en: 'Must be a number',
  },
  minLength: {
    en: 'Must be at least {length} characters',
  },
  maxLength: {
    en: 'Must be no more than {length} characters',
  },
  userName: {
    en: '<, >, \\, / symbols are not allowed',
  },
  streetAddress: {
    en: 'Must be a valid street address',
  },
  zipCode: {
    en: 'Must be a valid zip code',
  },
  telephone: {
    en: 'Must be a valid phone number',
  },
  cardNumber: {
    en: 'Must be a valid card number',
  },
  expDate: {
    en: 'Must be a valid date',
  },
  cardCVV: {
    en: 'Invalid CVV/CVC',
  },
  date: {
    en: 'Must be a valid date',
  },
  genderRequired: {
    en: 'Your gender is required',
  },
}
